import React, { useState } from 'react'
import { Box, Button, Typography, CircularProgress, Grid } from '@mui/material'
import { Form } from 'react-final-form'
import { useEditProfile } from '../../api/user'
import { useSnackbar } from 'notistack'
import { useAuth } from '../../api/context/UserAuthContext'

const wallpaperArray = [
  { src: '/wallpaper/Sea.jpg', name: 'Sea' },
  { src: '/wallpaper/Grass.jpg', name: 'Grass' },
  { src: '/wallpaper/Sand.jpg', name: 'Sand' },
  { src: '/wallpaper/Hills.jpg', name: 'Hills' },
  { src: '/wallpaper/City.jpg', name: 'City' },
]
export const EditProfileForm = (props) => {
  const { show, handleShowForm } = props

  const { user: data, fetchUser } = useAuth()

  const userId = data?._id

  const [wallpaper, setWallPaper] = useState(data?.imgSrc ?? wallpaperArray[0].src)

  const { enqueueSnackbar } = useSnackbar()

  const editProfileApi = useEditProfile()

  const onSubmit = async (values) => {
    const res = await editProfileApi
      .mutateAsync({ ...values, userId, imgSrc: wallpaper })
      .catch((e) => {
        enqueueSnackbar(e?.response?.data?.message ?? 'Fail to update profile', {
          variant: 'error',
        })
      })
    if (res.status === 200) {
      enqueueSnackbar('Profile updated', {
        variant: 'success',
      })
      fetchUser()
      handleShowForm()
    }
  }

  return (
    <Box display={show ? 'block' : 'none'}>
      <Form
        onSubmit={onSubmit}
        keepDirtyOnReinitialize //let data stay on the form
        // initialValues={}
        component={({ handleSubmit, submitting }) => {
          return (
            <form onSubmit={handleSubmit} noValidate>
              <Box display='flex' flexDirection='column' mt={3}>
                <Box mb={3}>
                  <Typography variant='h6' style={{ fontWeight: 'bold' }}>
                    Edit Profile
                  </Typography>
                </Box>

                <Typography style={{ fontSize: '18px' }}>Select wallpaper</Typography>
                <Grid container>
                  {wallpaperArray?.map((each, idx) => {
                    const isSelected = wallpaper === each.src
                    const handleOnClick = () => {
                      setWallPaper(each.src)
                    }
                    return (
                      <Grid item xs={6} sm={4} md={2} key={idx}>
                        <Button
                          onClick={handleOnClick}
                          values={each?.src}
                          style={{ border: isSelected ? `1px solid black` : `` }}
                        >
                          <img src={each?.src} width='100%' height='100%' />
                        </Button>
                      </Grid>
                    )
                  })}
                </Grid>
              </Box>

              <Box
                display='flex'
                justifyContent='space-between'
                py={3}
                sx={{ maxWidth: { xs: '200px', sm: '500px', md: '800px' } }}
              >
                <Button onClick={handleShowForm}>Cancel</Button>
                <Button
                  variant='contained'
                  type='submit'
                  disabled={submitting || editProfileApi.isLoading}
                >
                  {editProfileApi.isLoading && (
                    <Box mr={1}>
                      <CircularProgress size='1.5rem' />
                    </Box>
                  )}
                  Submit
                </Button>
              </Box>
            </form>
          )
        }}
      />
    </Box>
  )
}
